import { Box } from "@mui/material";
import React from "react";

const IconBox = ({ children }) => {
  return (
    <Box
      sx={{
        width: "100px",
        height: "100px",
        backgroundColor: "#F5F5F5",
        borderRadius: "8px",
        border: "1px solid #d8d8d8",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px",
      }}
    >
      {children}
    </Box>
  );
};

export default IconBox;
